import { getAuth } from "firebase/auth";
import { useEffect, useRef, useState } from "react";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import { MultipleQueryTypesense } from "../../../Typesense";
import getFiltersString from "./getFiltersString";
import { useContext } from "react";
import { resultsContext } from "../Properties";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import { db } from "../../../firebase";
const limitForDocs = 10;

export function useSharedProperties(
  Type,
  FiltersParams,
  areFiltersSetToDefault
) {
  // const { PriceRange, PropertySize, PropertyType, PropertySubType } =
  //   FiltersParams;
  const setResult = useContext(resultsContext);
  const [Properties, setProperties] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [paginationIndex, setPaginationIndex] = useState(1);
  const [Reset, setReset] = useState(true);

  const lastSharedSnapshot = useRef("*");
  const lastPublicSnapshot = useRef("*");

  const reset = () => {
    setProperties([]);
    setHasMore(true);
    setPaginationIndex(1);
    setReset(!Reset);
  };

  const fetchPropertiesFromTypesense = async () => {
    if (!hasMore) return;

    try {
      getAuth().onAuthStateChanged(async ({ uid }) => {
        const FilterStrings = getFiltersString(FiltersParams);
        let properties = (
          await MultipleQueryTypesense(
            {
              searches: [
                {
                  filter_by: `${FilterStrings[0]} && status:=shared && numberOfSharedParties:>0  && is_deleted:=false`,
                },
                {
                  filter_by: `${FilterStrings[1]} &&status:=shared && numberOfSharedParties:>0  && is_deleted:=false`,
                },
                {
                  filter_by: `${FilterStrings[0]}&& status:=public && is_deleted:=false`,
                },
                {
                  filter_by: `${FilterStrings[1]}&& status:=public && is_deleted:=false`,
                },
              ],
            },
            {
              query_by: "bid",
              q: getLocalStorageItem("bid"),
              collection: "properties",
              per_page: limitForDocs,
              page: paginationIndex,
              sort_by: "sharedAt: desc, _text_match:desc",
            }
          )
        ).map(({ document }) => document);

        let TotalProperties = [...Properties, ...properties];
        const PropertiesIds = TotalProperties.map(({ id }) => id);
        const UniquePropertiesIds = Array.from(new Set(PropertiesIds));

        TotalProperties = UniquePropertiesIds.map((uid) =>
          TotalProperties.filter(({ id }) => uid === id).pop()
        );

        setPaginationIndex(paginationIndex + 1);
        if (properties.length < limitForDocs) setHasMore(false);

        setProperties(TotalProperties);
        setResult(TotalProperties.length);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPropertiesFromFirestoreFirst = () => {
    if (!hasMore) return;

    try {
      getAuth().onAuthStateChanged(async ({ uid }) => {
        const PropertiesCollection = collection(db, "properties");
        let q = query(
          PropertiesCollection,
          where("bid", "==", getLocalStorageItem("bid")),
          where("status", "==", "shared"),
          where("is_deleted", "==", false),
          orderBy("sharedAt", "desc"),
          limit(limitForDocs)
        );
        const sp = await getDocs(q);

        let sharedProperties = sp.docs.map((e) => {
          return {
            ...e.data(),
            id: e.id,
          };
        });
        lastSharedSnapshot.current = sp.docs[sp.docs.length - 1];

        let publicProperties = await getDocs(
          query(
            collection(db, "properties"),
            where("bid", "==", getLocalStorageItem("bid")),
            where("status", "==", "public"),
            where("is_deleted", "==", false),
            orderBy("sharedAt", "desc"),
            limit(limitForDocs)
          )
        );

        lastPublicSnapshot.current =
          publicProperties.docs[publicProperties.docs.length - 1];
        publicProperties = publicProperties.docs.map((e) => {
          return { ...e.data(), id: e.id };
        });

        const fetchedProperties = [...sharedProperties, ...publicProperties];

        let TotalProperties = [...Properties, ...fetchedProperties];

        const PropertiesIds = TotalProperties.map(({ id }) => id);
        const UniquePropertiesIds = Array.from(new Set(PropertiesIds));

        TotalProperties = UniquePropertiesIds.map((uid) =>
          TotalProperties.filter(({ id }) => uid === id).pop()
        );

        setPaginationIndex(paginationIndex + 1);
        if (fetchedProperties.length < limitForDocs) {
          setHasMore(false);
        }

        setProperties(TotalProperties);
        setResult(TotalProperties.length);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const fetchPropertiesFromFirestoreAgain = () => {
    if (!hasMore) return;

    try {
      getAuth().onAuthStateChanged(async ({ uid }) => {
        const PropertiesCollection = collection(db, "properties");
        let q = query(
          PropertiesCollection,
          where("bid", "==", getLocalStorageItem("bid")),
          where("status", "==", "shared"),
          where("is_deleted", "==", false),
          orderBy("sharedAt", "desc"),
          startAfter(lastSharedSnapshot.current ?? ""),
          limit(limitForDocs)
        );
        let sp = await getDocs(q);
        lastSharedSnapshot.current = sp.docs[sp.docs.length - 1];

        let sharedProperties = sp.docs.map((e) => {
          return {
            ...e.data(),
            id: e.id,
          };
        });

        let publicProperties = await getDocs(
          query(
            collection(db, "properties"),
            where("bid", "==", getLocalStorageItem("bid")),
            where("status", "==", "public"),
            where("is_deleted", "==", false),
            orderBy("sharedAt", "desc"),
            startAfter(lastPublicSnapshot.current ?? ""),
            limit(limitForDocs)
          )
        );

        lastPublicSnapshot.current =
          publicProperties.docs[publicProperties.docs.length - 1];
        publicProperties = publicProperties.docs.map((e) => {
          return { ...e.data(), id: e.id };
        });

        const fetchedProperties = [...sharedProperties, ...publicProperties];

        let TotalProperties = [...Properties, ...fetchedProperties];

        const PropertiesIds = TotalProperties.map(({ id }) => id);
        const UniquePropertiesIds = Array.from(new Set(PropertiesIds));

        TotalProperties = UniquePropertiesIds.map((uid) =>
          TotalProperties.filter(({ id }) => uid === id).pop()
        );
        setPaginationIndex(paginationIndex + 1);

        if (fetchedProperties.length < limitForDocs) {
          setHasMore(false);
        }

        setProperties(TotalProperties);
        setResult(TotalProperties.length);
      });
    } catch (error) {
      console.log(error);
      setHasMore(false);
    }
  };

  const fetchPropertiesFromFirestore = () => {
    if (paginationIndex === 1) {
      fetchPropertiesFromFirestoreFirst();
    } else {
      fetchPropertiesFromFirestoreAgain();
    }
  };

  const fetchProperties = () => {
    if (areFiltersSetToDefault()) {
      fetchPropertiesFromFirestore();
    } else {
      fetchPropertiesFromTypesense();
    }
  };

  useEffect(() => fetchProperties(), [Reset]);
  useEffect(() => reset(), [FiltersParams]);
  // useEffect(() => {
  //   if (Properties === []) {
  //     fetchProperties();
  //   }
  // }, []);

  return [Properties, fetchProperties, hasMore];
}
